import { createReducer } from '@reduxjs/toolkit';
import { isArray, mergeWith, union } from 'lodash';
import { setAvailability } from '../../actions/availability';

export const initialState = window.ecom.redux_initial_state.availability || {};

const AvailabilityReducer = createReducer(initialState, {
  [setAvailability]: (state, action) => {
    const unionArrays = (a, b) => {
      if (isArray(a) && isArray(b)) {
        return union(a, b);
      }
    };
    return mergeWith({}, state, action.payload, unionArrays);
  },
});

export default AvailabilityReducer;
